import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';


const PieNivelGov = ({data, title}) =>{


    

    return(<>
            <h4>{title || 'Nível de Acesso GovBR'}</h4> 
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie data={data} dataKey="value" nameKey="level" cx="50%" cy="50%" outerRadius={60} innerRadius={30} label>
                  <Cell nameKey='gold' name='Ouro' fill={'#FFD700'} />
                  <Cell nameKey='silver' name='Prata' fill={'#C0C0C0'} />
                  <Cell nameKey='bronze' name='Bronze' fill={'#CD7F32'} />
                </Pie>
                <Tooltip />
                <Legend/>
              </PieChart>
            </ResponsiveContainer>
        </>)

}


export default PieNivelGov